export { QuickShop } from './QuickShop';
